<template>
  <el-dialog
    :title="rateCard.name + ': ' + (rate.exists ? 'Edit Existing' : 'Create New') + ' Rate'"
    visible
    width="80vw"
    top="5vh"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="$emit('update:isShow', false)"
  >
    <el-form
      ref="rateForm"
      v-loading="isSaving"
      :rules="rules"
      :model="rate"
      size="small"
    >
      <el-row :gutter="15">
        <el-col :md="8">
          <el-row :gutter="15">
            <el-col :md="12">
              <el-form-item
                label="Accumulative"
                prop="accumulative"
              >
                <el-select
                  v-model="rate.accumulative"
                  placeholder=""
                  class="w-100"
                >
                  <el-option
                    label="Yes"
                    :value="1"
                  />
                  <el-option
                    label="No"
                    :value="0"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item
                label="Reciprocal"
                prop="reciprocal"
              >
                <el-select
                  v-model="rate.reciprocal"
                  placeholder=""
                  class="w-100"
                >
                  <el-option
                    label="Yes"
                    :value="1"
                  />
                  <el-option
                    label="No"
                    :value="0"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Cubic"
            prop="cubic"
          >
            <el-input-number
              v-model="rate.cubic"
              controls-position="right"
              :min="0"
              placeholder=""
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Minimum Charge"
            prop="min_charge"
          >
            <el-input-number
              v-model="rate.min_charge"
              controls-position="right"
              :min="0"
              :precision="4"
              placeholder=""
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :md="6">
          <el-form-item
            label="Unit Size"
            prop="unit_size"
          >
            <el-input-number
              v-model="rate.unit_size"
              controls-position="right"
              :min="0"
              placeholder=""
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="Cube Limit"
            prop="cube_limit"
          >
            <el-input-number
              v-model="rate.cube_limit"
              controls-position="right"
              :min="0"
              :precision="4"
              placeholder=""
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="KG Limit"
            prop="weight_limit"
          >
            <el-input-number
              v-model="rate.weight_limit"
              controls-position="right"
              :min="0"
              placeholder=""
              class="w-100"
            />
          </el-form-item>
        </el-col>
        <el-col :md="6">
          <el-form-item
            label="KG Rounding"
            prop="round_weights_to"
          >
            <el-input-number
              v-model="rate.round_weights_to"
              controls-position="right"
              :min="0"
              :max="1000"
              :precision="2"
              placeholder=""
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <hr>
      <el-row :gutter="15">
        <el-col :md="8">
          <el-form-item
            label="Services"
            prop="carrier_service"
          >
            <el-select
              v-model="rate.carrier_service"
              value-key="id"
              filterable
              placeholder=""
              :loading="isLoadingServices"
              class="w-100"
              :disabled="!!rate.id"
              clearable
            >
              <el-option
                v-for="service in services"
                :key="service.id"
                :label="service.name"
                :value="service"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Zone From"
            prop="zone_from"
          >
            <el-select
              v-model="rate.zone_from"
              value-key="id"
              filterable
              placeholder=""
              :loading="isLoadingZones"
              class="w-100"
              :disabled="!!rate.id"
              clearable
            >
              <el-option
                v-for="zone in zones"
                :key="zone.id"
                :label="zone.zone.desc"
                :value="zone.zone"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item
            label="Zone To"
            prop="zone_to"
          >
            <el-select
              v-model="rate.zone_to"
              value-key="id"
              filterable
              placeholder=""
              :loading="isLoadingZones"
              class="w-100"
              :disabled="!!rate.id"
              clearable
            >
              <el-option
                v-for="zone in zones"
                :key="zone.id"
                :label="zone.zone.desc"
                :value="zone.zone"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click.native="$emit('update:isShow', false)">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="typeof rate.id !== 'undefined' ? updateRate() : createRate()"
      >
        {{ typeof rate.id !== 'undefined' ? 'Save' : 'Create' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    carrierId: {
      type: String,
      required: true
    },
    rateCard: {
      type: Object,
      required: true
    },
    rate: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isSaving: false,
      isFullscreen: false,
      services: [],
      isLoadingServices: false,
      zones: [],
      isLoadingZones: false,
      rules: {
        carrier_service: [
          { required: true, message: 'Carrier Service is required', trigger: 'change' }
        ],
        zone_from: [
          { required: true, message: 'Zone From is required', trigger: 'change' }
        ],
        zone_to: [
          { required: true, message: 'Zone To is required', trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadLists()
  },
  methods: {
    loadLists () {
      // Services
      this.isLoadingServices = true
      this.$sdk.carrier_service.list(builder => {
        builder.context = { resource: 'carrier', id: this.carrierId }
        builder.limit = 500
      }).then(res => { this.services = res })
        .finally(() => { this.isLoadingServices = false })
      // Zones
      this.isLoadingZones = true
      this.$sdk.locationcarrierzone.list(builder => {
        builder.context = { resource: 'pivot' }
        builder.include = ['carrier', 'zone']
        builder.limit = 500
        builder.filters = { pivot_location_carrier_zone_carrier: this.carrierId, pivot_location_carrier_zone_grouped: true }
      }).then(res => { this.zones = res })
        .finally(() => { this.isLoadingZones = false })
    },
    createRate () {
      this.$refs.rateForm.validate(valid => {
        if (valid) {
          this.isSaving = true
          this.rate.rate_card = this.rateCard
          this.$sdk.ratecard_rate.create(this.rate)
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    },
    updateRate () {
      this.$refs.rateForm.validate(valid => {
        if (valid) {
          this.isSaving = true
          this.rate.update()
            .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
            .finally(() => {
              this.isSaving = false
              this.$emit('saved')
              this.$emit('update:isShow', false)
            })
        }
      })
    }
  }
}
</script>

<style>

</style>
